import { render, staticRenderFns } from "./provisional.vue?vue&type=template&id=233eec58&"
import script from "./provisional.vue?vue&type=script&lang=js&"
export * from "./provisional.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports